import { render, staticRenderFns } from "./SourceTooltipIcon.vue?vue&type=template&id=bb97a5ea"
import script from "./SourceTooltipIcon.vue?vue&type=script&lang=js"
export * from "./SourceTooltipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports